
    import { Vue } from 'vue-class-component';

    export default class Disclaimer extends Vue {

        // translations
        public get messages_disclaimer () { return this.$t('messages.disclaimer') }

    }
